import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Container,
  TextField,
  InputAdornment
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SearchIcon from '@mui/icons-material/Search';
import BuildIcon from '@mui/icons-material/Build';

const utilities = [
  {
    id: 'whatsapp-animator',
    title: 'WhatsApp Conversation Animator',
    description: 'Create and animate realistic WhatsApp conversations for demos, tutorials, or fun.',
    icon: <WhatsAppIcon sx={{ fontSize: 80, color: '#25D366' }} />,
    link: '/whatsapp-animator'
  },
  {
    id: 'coming-soon',
    title: 'More Utilities Coming Soon',
    description: 'Stay tuned for more productivity and creative tools!',
    icon: <BuildIcon sx={{ fontSize: 80, color: '#1976D2' }} />,
    link: '#'
  }
];

const HomePage = () => {
  const [search, setSearch] = useState('');
  const filteredUtilities = utilities.filter(u =>
    u.title.toLowerCase().includes(search.toLowerCase()) ||
    u.description.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 6, textAlign: 'center' }}>
        <Typography variant="h2" component="h1" gutterBottom>
          ToolNest
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph>
          Your all-in-one platform for productivity, creativity, and everyday digital tools.
        </Typography>
        <Box sx={{ mt: 4, mb: 3, maxWidth: 400, mx: 'auto' }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search utilities..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      <Grid container spacing={4}>
        {filteredUtilities.length === 0 ? (
          <Grid item xs={12}>
            <Typography variant="h6" color="text.secondary" align="center">
              No utilities found.
            </Typography>
          </Grid>
        ) : (
          filteredUtilities.map((utility) => (
            <Grid item xs={12} sm={6} md={4} key={utility.id}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
                  }
                }}
              >
                <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', bgcolor: 'background.paper' }}>
                  {utility.icon}
                </Box>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography gutterBottom variant="h5" component="h2">
                    {utility.title}
                  </Typography>
                  <Typography>
                    {utility.description}
                  </Typography>
                </CardContent>
                <Box sx={{ p: 2 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    component={RouterLink}
                    to={utility.link}
                    disabled={utility.link === '#'}
                  >
                    {utility.link === '#' ? "Coming Soon" : "Open"}
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
};

export default HomePage;
